import { render, staticRenderFns } from "./ClonarCategoriasComponent.vue?vue&type=template&id=c90755ae&"
import script from "./ClonarCategoriasComponent.vue?vue&type=script&lang=js&"
export * from "./ClonarCategoriasComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClonarCategoriasComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports